import { NAV } from "../data";

export const Footer = ({ onBook }) => (
  <footer id="contatti-footer" data-testid="footer" className="bg-[var(--anthracite)] text-white pt-24 pb-10">
    <div className="max-w-7xl mx-auto px-6 sm:px-12">
      <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-white/15">
        <div className="md:col-span-6">
          <div className="overline !text-white/60 mb-5">Naviga</div>
          <ul className="grid grid-cols-2 gap-3">
            {NAV.map((n) => (
              <li key={n.href}><a href={n.href} className="link-underline text-white/80">{n.label}</a></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4 md:col-start-9">
          <div className="overline !text-white/60 mb-5">Contatti</div>
          <a href="mailto:gabriellaritondo@gmail.com" className="link-underline text-white/90 block mb-4">gabriellaritondo@gmail.com</a>
          <button data-testid="footer-book-btn" onClick={onBook}
            className="btn-fill inline-flex text-xs font-semibold uppercase tracking-[0.15em] border border-white text-white hover:text-[var(--anthracite)] px-6 py-3"
            style={{ "--accent": "#ffffff" }}>
            Prenota una Executive Call
          </button>
        </div>
      </div>
      <div className="pt-10 flex flex-col sm:flex-row justify-between items-center gap-4">
        <span className="text-xs text-white/40">© {new Date().getFullYear()} Gabriella Ritondo Holding. Tutti i diritti riservati.</span>
        <div className="flex items-center gap-6 flex-wrap justify-center">
          <a href="/privacy-policy" data-testid="footer-privacy-link" className="text-xs text-white/40 hover:text-white/80 link-underline">Privacy Policy</a>
          <a href="/cookie-policy" data-testid="footer-cookie-link" className="text-xs text-white/40 hover:text-white/80 link-underline">Cookie Policy</a>
          <button data-testid="footer-cookie-prefs" onClick={() => { localStorage.removeItem("gr_consent"); window.location.reload(); }}
            className="text-xs text-white/40 hover:text-white/80 link-underline">Preferenze cookie</button>
          <a href="/admin" data-testid="footer-admin-link" className="text-xs text-white/40 hover:text-white/80 link-underline">Area riservata</a>
          <span className="text-xs text-white/40 uppercase tracking-[0.15em]">Board Advisory · AI Governance · Digital</span>
        </div>
      </div>
      <div className="font-serif text-[6.5vw] leading-none text-white/[0.05] text-center mt-12 select-none tracking-tight whitespace-nowrap">Maria Gabriella Ritondo Holding</div>
    </div>
  </footer>
);
